/**
 * abilityVfxJudgment — Garen E Judgment sword whirlwind (SP-07).
 */
export function buildJudgment(THREE, spec) {
  const group = new THREE.Group();
  const s = spec.scale || 1.85;
  const gold = mat(THREE, spec.color || 0xfbbf24, 0.88);
  const steel = mat(THREE, 0xfef3c7, 0.92);
  addSpinSwords(THREE, group, s, gold, steel);
  addTrailAndRing(THREE, group, s, gold);
  group.userData = { shape: 'judgment' };
  return group;
}

function addSpinSwords(THREE, group, s, gold, steel) {
  for (let i = 0; i < 4; i += 1) {
    const blade = new THREE.Mesh(new THREE.BoxGeometry(s * 1.05, 0.07, 0.16), steel);
    blade.position.y = 0.5;
    if (!blade.rotation) blade.rotation = { y: 0 };
    blade.rotation.y = (Math.PI / 2) * i;
    group.add(blade);
    const tip = new THREE.Mesh(new THREE.ConeGeometry(0.1, 0.28, 4), gold);
    tip.position.set(Math.cos((Math.PI / 2) * i) * s * 0.55, 0.5, Math.sin((Math.PI / 2) * i) * s * 0.55);
    if (!tip.rotation) tip.rotation = { y: 0 };
    tip.rotation.y = (Math.PI / 2) * i;
    group.add(tip);
  }
}

function addTrailAndRing(THREE, group, s, gold) {
  for (let i = 0; i < 4; i += 1) {
    const trail = new THREE.Mesh(new THREE.BoxGeometry(s * 0.55, 0.04, 0.08), gold);
    trail.position.y = 0.42;
    if (!trail.rotation) trail.rotation = { y: 0 };
    trail.rotation.y = (Math.PI / 2) * i + Math.PI / 4;
    group.add(trail);
  }
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.35, s * 0.55, 24).rotateX(-Math.PI / 2),
    gold
  );
  ring.position.y = 0.05;
  group.add(ring);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
